'use client'

import classNames from 'classnames'

interface SwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  id?: string
  className?: string
}

const Switch: React.FunctionComponent<SwitchProps> = ({
  checked,
  onChange,
  label,
  id = 'switch',
  className,
}) => {
  return (
    <label
      htmlFor={id}
      className={classNames(
        'inline-flex items-center gap-2 cursor-pointer select-none',
        className,
      )}
    >
      {label && <span className="text-sm text-gray-dark">{label}</span>}
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={() => onChange(!checked)}
        className={classNames(
          // p-0.5 rather than nudging the knob: it makes the gap around the
          // knob the track's padding, so it stays 2px on whichever side the
          // knob is resting. Offsetting the knob instead left 2px on the
          // left when OFF but 4px on the right when ON (TSE-358).
          'relative inline-flex h-6 w-11 shrink-0 rounded-full p-0.5 transition-colors',
          checked ? 'bg-primary' : 'bg-gray-50',
        )}
      >
        <span
          className={classNames(
            'inline-block h-5 w-5 rounded-full bg-white transition-transform',
            checked ? 'translate-x-5' : 'translate-x-0',
          )}
        />
      </button>
    </label>
  )
}

export default Switch
